import styled from "styled-components";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const IntroSegmentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding:${isMobile()?"30px 20px":"100px 55px"};
  box-sizing:border-box;
  flex-direction:${isMobile()?"column":"row"};
`;

export const TextSegment = styled.div`
  width: ${isMobile()?"100%":"60%"};
  padding-right:${isMobile()?"0":"150px"};
  padding-bottom:${isMobile()?"30px":"0px"};
  box-sizing: border-box;
`;
export const HeadingText = styled.div`
  ${fonts.headings};
  font-size: 35px;
  font-weight: bold;
  margin-bottom:50px;
  ${
    isMobile() && `
      text-align:center;
      font-size:24px;
    `
  }
`;
export const SubText = styled.div`
  ${fonts.text};
  font-size: 16px;
  margin-bottom:50px;
`;
export const IntroImageContainer = styled.div`
  width: ${isMobile()?"90%":"35%"};
`;
export const IntroImage = styled.img`
  width: 100%;
  border-radius:20px;
`;
